<template>
  <div
    class="annotation-page-cover-up-popbox"
    v-show="isAnnotating"
    @click.self="handleAnnotationPageCoverUpPopboxClicked()"
  ></div>

  <!-- the #favoritesList select is used by ChartNotes to populate the ChartLists select-menu when the user saves a new chart via ChartNotes -->
  <select id="favoritesList" style="display: none;">
    <option
      v-for="chartList in savedChartsStore.chartLists"
      :key="chartList.recid"
      :value="chartList.listNum"
    >{{ chartList.htmlSanitizedName }}</option>
  </select>
</template>

<script setup>
  import { useSavedChartsStore } from '@/stores/savedChartsStore';
  import { useChartNotesV2 } from '@/composables/useChartNotesV2';
  import { wait } from '@/utils/wait';

  const savedChartsStore = useSavedChartsStore();
  const { isAnnotating, isChartNotesFullyInitialized } = useChartNotesV2();

  async function handleAnnotationPageCoverUpPopboxClicked() {
    if (!isChartNotesFullyInitialized()) {
      return;
    }

    await wait(0);

    if (!isChartNotesFullyInitialized()) {
      return;
    }

    window.chartNotes.onCloseRequest();
  }
</script>

<style>
  .annotation-page-cover-up-popbox {
    position: fixed;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #333;
    opacity: 0.5;
  }

  #stylemenu,
  .sp-container,
  .ui-dialog,
  .ui-dialog ~ table,
  textarea {
    z-index: 1001 !important;
    line-height: 1.42857143;
  }

  table#stylemenu,
  #stylemenu table {
    border-collapse: collapse;
  }

  table#stylemenu td,
  #stylemenu table td,
  table#stylemenu th,
  #stylemenu table th {
    padding: 0px;
  }

  #cnHelpDialog table td {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 1px;
  }

  div.ui-dialog.ui-widget {
    font-size: 15.4px;
    padding: 3.08px;
  }

  div.ui-dialog.ui-widget div.ui-dialog-titlebar {
    padding: 4.928px 12.32px;
  }

  div.ui-dialog.ui-widget .ui-dialog-title {
    margin: 1.232px 0px;
  }

  div.ui-dialog.ui-widget .ui-dialog-titlebar-close {
    right: 3.696px;
  }

  div.ui-dialog.ui-widget div.ui-widget-content {
    padding: 6px 12px;
  }

  div.ui-dialog.ui-widget div.ui-dialog-buttonpane button {
    margin: 5.7px 4.56px 5.7px 0px;
    font-size: 11.4px;
    padding: 4.56px 11.4px;
  }

  div.ui-dialog.ui-widget div.ui-dialog-buttonpane {
    padding: 3.696px 12.32px 6.16px 4.928px;
  }

  #new_chart input,
  #new_chart select {
    padding: 1px 2px;
    height: auto;
    border: 1px solid rgb(118, 118, 118);
    color: rgb(34, 34, 34);
    font-weight: 400;
    border-radius: 2px;
  }

  #new_chart input:hover,
  #new_chart select:hover {
    border-color: rgb(79, 79, 80);
  }

  #new_chart input:focus-visible,
  #new_chart select:focus-visible {
    outline: 2px solid rgb(0, 95, 204);
    outline-offset: -1px;
  }

  #new_chart select {
    padding: 0px;
  }

  .ui-widget-content a {
    text-decoration: none;
    border-radius: 2px;
  }

  .ui-widget-content a:hover {
    color: #3281d0;
  }

  .ui-widget-content a:focus,
  .ui-widget-content a:focus-visible {
    outline: 2px solid rgb(0, 95, 204);
  }

  div.ui-dialog.ui-widget div.ui-dialog-titlebar,
  div.ui-dialog.ui-widget div.ui-helper-clearfix::before,
  div.ui-dialog.ui-widget div.ui-helper-clearfix::after,
  div.ui-dialog.ui-widget span.ui-dialog-title,
  div.ui-dialog.ui-widget button.ui-button,
  div.ui-dialog.ui-widget span.ui-button-icon,
  div.ui-dialog.ui-widget span.ui-button-icon-space,
  div.ui-dialog.ui-widget div.ui-dialog-buttonpane,
  div.ui-dialog.ui-widget div.ui-dialog-buttonpane::before,
  div.ui-dialog.ui-widget div.ui-dialog-buttonpane::after {
    font-size: 12.32px;
  }
</style>
